import {
  getFormData,
  resetFormErrors,
  showFormErrors,
} from '../../utils/form';
import {initCustomFieldsTagsInput, setCustomFieldsData} from "../../utils/custom_fields";
import * as fromFields from '../../components/forms/fields';
import $jsAPI from "../../front_end_api";
import {
  handleCaptcha,
  initCaptcha,
  resetCaptcha,
  resetCaptchaVerificationStatus,
} from "../../utils/captcha";
import trans from "../../utils/trans";

class AbstractJobApplyForm {

  prevStepFormId;
  nextStepFormId;
  currentStepForm;
  currentStepFormId;
  currentStepFormContainer;
  stepsExistingForApply;
  haveCaptcha;
  currentStep;

  constructor(currentStepFormId) {
    if (new.target === AbstractJobApplyForm) {
      throw new Error("Cannot instantiate an abstract class.");
    }

    this.stepsExistingForApply = Object.keys(window.$customFields);
    this.stepsExistingForApply.push('job-apply-form-step-review')

    this.currentStepFormId = currentStepFormId;
    this.currentStepForm = $(`#${currentStepFormId}`);
    this.currentStepFormContainer = this.currentStepForm.closest('.form-step-container');
    this.prevStepFormId = this.getAdjacentStepFormId('prev');
    this.nextStepFormId = this.getAdjacentStepFormId('next');
    this.haveCaptcha = false;
  }

  initPage () {
    if (!this.currentStepForm.length) {
      return ;
    }

    if (this.haveCaptcha) {
      initCaptcha(() => {
        this.submitCurrentStepData();
      });
      this.currentStepForm.submit(handleCaptcha(
        (e) => {
          this.submitCurrentStepData();

          return false;
        },
        'captcha-container',
        true
      ));
    } else {
      this.currentStepForm.submit(() => {
        this.submitCurrentStepData();
        return false;
      });
    }

    $('.previous-step', this.currentStepFormContainer).click( event => {
      event.preventDefault();
      this.previousStep();
    });

    $('.edit-step', this.currentStepFormContainer).click( event => {
      event.preventDefault();

      const formId = $(event.target).closest('.edit-step').data('form-id')
      this.editStep(formId);
    });
  };

  showCurrentStepFormErrors (response) {
    showFormErrors(this.currentStepForm, response);

    if (response.data && response.data.errors && (response.data.errors.file || response.data.errors.resume)) {
      $(".form-field-file-container").addClass('dz-container-error');
    } else {
      $(".form-field-file-container").removeClass('dz-container-error');
    }
  };

  resetCurrentStepFormErrors () {
    resetFormErrors(this.currentStepForm);
    $(".form-field-file-container").removeClass('dz-container-error');
  };

  async submitCurrentStepData () {
    const data = this.getApplyFormData();
    this.currentStep = data['step'];

    $('.btn-submit', this.currentStepForm).loading();

    try {
      const response = await axios.post(this.currentStepForm.attr('action'), data);

      this.resetCurrentStepFormErrors();

      this.handleResponse(response);
    } catch (e) {
      $('.btn-submit', this.currentStepForm).loading(false);
      console.log('error', e);
      this.showCurrentStepFormErrors(e.response);

      if (data['step'] === 'basic_info' && !window.draftJobApplication) {
        resetCaptchaVerificationStatus();
        resetCaptcha();
      }
    }
  };

  getApplyFormData () {
    const data = getFormData(this.currentStepForm);

    if (data.custom_fields) {
      data.custom_fields = setCustomFieldsData(data.custom_fields, this.currentStepForm.attr('id'));
    }

    return data;
  }

  handleResponse(response) {
    if (response.status === 200) {
      window.draftJobApplication = response.data.item;

      this.removeTermsCheckbox();

      if (response.data.fieldsValuesForReviewStep) {
        this.setReviewStepData(response.data.fieldsValuesForReviewStep);
      }

      if (!response.data.item.draft) {
        $jsAPI.fireEvent('job:application_submitted', window.job, response.data.item);

        const redirectUrl = $('.form-steps').data('success-redirect');
        window.location.replace(redirectUrl);
      } else {
        $('.btn-submit', this.currentStepForm).loading(false);

        if (response.data.lastCompletedStepUpdated) {
          this.fireStepsEvent();
        }

        this.nextStep();
      }
    }
  }

  setReviewStepData(fieldsValuesForReviewStep) {
    const emptyValue = `<i>${trans('job_apply.step.review.empty_value')}</i>`;

    for (const stepName in fieldsValuesForReviewStep) {
      for (const field of fieldsValuesForReviewStep[stepName]) {
        const finalFieldElement = document.getElementById('final_field_' + field.id);
        if (!finalFieldElement) continue;

        let value = field.value;

        // Handle resume file links
        if (field.core_column_name === 'resume_file_id') {
          const link = finalFieldElement.querySelector('a');
          if (link) {
            link.href = value?.url || '';

            if (value?.file_name) {
              link.textContent = value?.file_name;
            } else {
              link.innerHTML = emptyValue;
            }
          }
          continue;
        }

        // Check if value is an object for numeric range fields
        const isObject = value && typeof value === 'object';
        const isNumericRange = isObject && ('from' in value || 'to' in value);

        // Handle numeric range values
        if (isNumericRange) {
          if (!value['from'] && !value['to']) {
            finalFieldElement.textContent = trans('forms.field.numeric_range.display.empty');
          } else if (value['from'] && !value['to']) {
            finalFieldElement.textContent = trans('forms.field.numeric_range.display.from_only', { 'FROM_NUMBER': value['from'] });
          } else if (!value['from'] && value['to']) {
            finalFieldElement.textContent = trans('forms.field.numeric_range.display.to_only', { 'TO_NUMBER': value['to'] });
          } else if (value['from'] && value['to']) {
            finalFieldElement.textContent = trans('forms.field.numeric_range.display.from_to', { 'FROM_NUMBER': value['from'], 'TO_NUMBER': value['to'] });
          }
          continue;
        }

        // Handle checkbox
        if (field.field_type === 'checkbox') {
          finalFieldElement.textContent = field.value === true ? trans('general.checkbox.yes') : trans('general.checkbox.no');
          continue;
        }

        // Handle file upload — the review response contains only a display name and short-lived download URL.
        if (field.field_type === 'file_upload') {
          const fileName = isObject ? value.file_name : null;
          const fileUrl = isObject ? value.url : null;
          if (fileName && fileUrl) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.target = '_blank';
            link.rel = 'noopener nofollow';
            link.className = 'text-reset text-underlined';
            link.textContent = fileName;
            finalFieldElement.replaceChildren(link);
          } else if (fileName) {
            finalFieldElement.textContent = fileName;
          } else {
            finalFieldElement.innerHTML = emptyValue;
          }
          continue;
        }

        if (field.field_type === 'rich_text') {
          finalFieldElement.innerHTML = value ?? emptyValue;
          continue;
        }

        // Handle other field values
        if (value) {
          if (Array.isArray(value)) {
            value = value.join(', ');
          }
          finalFieldElement.textContent = value;
        } else {
          finalFieldElement.innerHTML = emptyValue;
        }
      }
    }
  }

  fireStepsEvent() {
    let eventName = null;

    switch (this.currentStep) {
      case 'basic_info':
        eventName = 'job:application_contact_information_step_completed';
        break;
      case 'resume_info':
        eventName = 'job:application_resume_step_completed';
        break;
      case 'additional_info':
        eventName = 'job:application_additional_information_step_completed';
        break;
    }

    if (eventName) {
      $jsAPI.fireEvent(eventName, window.job, window.draftJobApplication);
    }
  }

  getAdjacentStepFormId (direction) {
    const currentIndex = this.stepsExistingForApply.indexOf(this.currentStepFormId);

    if (currentIndex === -1) return null; // If the active step is not found

    if (direction === 'prev' && currentIndex > 0) {
      return this.stepsExistingForApply[currentIndex - 1];
    } else if (direction === 'next' && currentIndex < this.stepsExistingForApply.length - 1) {
      return this.stepsExistingForApply[currentIndex + 1];
    }

    return null; // No previous or next step available
  }

  stepTransition(direction, prevFormId = null) {
    $(window).scrollTop(0);

    const prevStepFormId = prevFormId ?? this.prevStepFormId;

    const stepFormContainer = $(`#${direction === 'next' ? this.nextStepFormId : prevStepFormId}`).closest('.form-step-container');
    stepFormContainer.addClass('active-step');

    const width = this.currentStepFormContainer.outerWidth();
    const translateX = -width; // Calculate the translate x value

    $('.form-steps').css({'--translate-x': `${translateX}px`}).addClass(direction === 'next' ? 'slide-left' : 'slide-right');
    $('.form-step-container').css({'max-width': `${width}px`});

    $('.form-steps').one('animationend', () => {
      $('.form-steps').css({'--translate-x': ``}).removeClass(direction === 'next' ? 'slide-left' : 'slide-right');
      this.currentStepFormContainer.removeClass('active-step');
      $('.form-step-container').css({'max-width': ''});
    });
  }

  previousStep() {
    this.stepTransition('prev');
  }

  nextStep() {
    this.stepTransition('next');
  }

  editStep(prevFormId) {
    this.stepTransition('prev', prevFormId);
  }

  removeTermsCheckbox() {
    $('#job-apply-form-container .terms-and-conditions-container').remove();
  }
}

export default AbstractJobApplyForm;
